import { createUseStyles } from 'react-jss'
import { card } from '../common'
import { bigBorderRadius } from '../const/common'

import { CARD_LIST_ITEM_CLASSNAME } from '../../constants/pdf'

const useStyles = createUseStyles({
  [CARD_LIST_ITEM_CLASSNAME]: {
    extend: card,
    borderRadius: bigBorderRadius,
    padding: '12px 8px 14px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overFlow: 'hidden'
  },
  cardSliderPreviewWrapper: {
    flexGrow: 1
  }
})

export default useStyles
